export enum FeatureFlagName {

  // Accessibility Features
  qti_accessibility_tools_read_aloud = "qti_accessibility_tools_read_aloud",
  
  // Feedback Features
  qti_student_feedback = "qti_student_feedback",
  
  // Calculator Features
  qti_accessibility_tools = "qti_accessibility_tools",
  
  // Navigation Features
  qti_items_navigator = "qti_items_navigator",
  
  // Assessment Features
  qti_assessment_upload = "qti_assessment_upload",
  qti_assessment_results = "qti_assessment_results",

  // Video Caption Features
  video_use_mux_captions_students = "video_use_mux_captions_students",

  // Applied Math formula sheet, shared with Ready's WorkKeys app
  student_experience_formula_sheet = "student_experience_formula_sheet",

  // TI-108 calculator on WKAM quizzes (Ready#7749), shared with Ready's WorkKeys app
  student_experience_calculator = "student_experience_calculator",
}

export type FeatureFlagStrategy = {
  name: string
  parameters: any
}

export type FeatureFlagBase = {
  name: string
  enabled: boolean
}

export type FeatureFlag = FeatureFlagBase & {
  description?: string
  strategies?: FeatureFlagStrategy[]
}

export type FeatureFlagStatesType = Partial<{
  [name in FeatureFlagName]: boolean
}>
